
import axios from 'axios'
import { log } from './debug';
import { getServer } from './server';
import {generateQuickGuid} from './uid'
let fetching = false; 

const postOrder = (order,store,debug, callback) => {
    
    if(fetching){
        return; 
    }

    fetching=true;
    const serverEnv =getServer(); 
    const endpoint =serverEnv.server;  

    const postEndpoint = `${endpoint}/orders/create`; 
    const post = getOrderPost(generateQuickGuid(),order,store); 
    const ticketEndpoint = `${endpoint}/ticket`; 

   
    log.message("postEndpoint","post:",postEndpoint); 
    log.message("postOrder","post:",post); 
   

    axios.post(postEndpoint,post)
    .then(res=>{   
       
        const response={
            ...res.data, 
            link: `${ticketEndpoint}/${res.data.id}`, 
        }
       
        callback(response);
        fetching=false;
     })
    .catch(err=>{
       console.error(err);
       console.debug('err', err.response);
       callback();
       fetching=false;
    });
}


const getOrderPost= (rtId,order,store)=>{

    if(order.type==='AUTO') 
        return getLocalOrderPost(rtId,order,store); 

    let endPoint={
        details:undefined,
        address:undefined, 
        latitude:undefined,
        longitude:undefined
    }

    if(order.type=="delivery" && order.fullAddress){
        endPoint   = {
            details:order.fullAddress.details,
            address:order.fullAddress.address, 
            latitude:order.fullAddress.geopoint.latitude,
            longitude:order.fullAddress.geopoint.longitude, 
            placeId:order.fullAddress.placeId
        }

        if(order.clientInfo && order.clientInfo.name){
            endPoint.name = order.clientInfo.name; 
        }
        if(order.clientInfo && order.clientInfo.phone){
            endPoint.phone = order.clientInfo.phone; 
        }
   }
    
    const startPoint = {
        name: order.pickupAddress.name,
        details:order.pickupAddress.details,
        address:order.pickupAddress.address, 
        latitude:order.pickupAddress.geopoint.latitude,
        longitude:order.pickupAddress.geopoint.longitude, 
        placeId:order.pickupAddress.placeId
    }

    const deliveryData={
        ...order.deliveryPrice, 
    }

    let code = "NONE"
    if (store.currency.style){
        code = store.currency.style.code
    }

    const onlineOrder =  {
        location:store.id.toString(),
        client:order.clientInfo.id,
        messageToken:"online",
        rtId:rtId,
        type:order.type.toUpperCase(),
        data:{
            
              pickupAddress:  startPoint, 
              targetAddress:  endPoint, 
              list:order.list,
              deliveryData:deliveryData, 
             
              payMethod:order.payMethod,
              currency:code, 
              totalPrice:order.totalPrice, 
              clientInfo:order.clientInfo,
              app: "ONLINEORDER",

              //TODO WILL BE DEPRECATED
              payment:order.payMethod?.id?.toUpperCase(),
              type:order.type,             
        }
    }

    if(store.isDemo){
        onlineOrder.data.demoPhone=store.phone;
        onlineOrder.data.app="TEST_WHATSAPP"; 
        onlineOrder.messageToken="demo"; 
    }

    return onlineOrder; 

}



const getLocalOrderPost= (rtId,order,store)=>{

    const postNewOrder =  {
        location:store.id.toString(),
        client:order.clientInfo.id,
        messageToken:"auto",
        placeId:order.clientInfo?.table,
        rtId:rtId,
        type:order.type.toUpperCase(), 
        data:{
              list:order.list,
              payMethod:order.payMethod,
              currency:"NONE", 
              totalPrice:order.totalPrice, 
              clientInfo:order.clientInfo,
              targetAddress:  {placeId:order.clientInfo?.table}, //DEPRECATED
              app: "SELFORDER",
              type:order.type,        
        }
    }
    if (store.currency.style){
        postNewOrder.data.currency = store.currency.style.code; 
    }
    return postNewOrder; 
}




export default postOrder